import PageImage from 'tsui/PageImage';

export default function PageLogo() {
    const decor = theme_.homePageHeaderTheme.logo;

    if (!decor.show) return <></>;

    return <PageImage src={decor.src!} sx={decor.sx()} />;
}
